const alertArray = [
  {
    time: "14:01:33",
    client: "Alambicx",
    ticker: "AAPL",
    title: "price limit",
    urgent: "1",
    message: "IBCP Total Order Quantity: 9,753 - Day Vol: 7,354 - % Vol: 132.62"
  },
  {
    time: "14:01:32",
    client: "Alambicx",
    ticker: "PBR",
    title: "order reject",
    urgent: "1",
    message: "PendingNew Order Quantity: 2,000,000 - Last Shares: N/A"
  },
  {
    time: "14:01:31",
    client: "Alambicx",
    ticker: "HOG",
    title: "order quantity",
    urgent: "1",
    message:
      "PartiallyFilled Order Quantity: 1,618,520 -Total Notional: 13,433,716"
  },
  {
    time: "14:01:30",
    client: "balyasnyx",
    ticker: "ITUB",
    title: "aggregate volume",
    urgent: "1",
    message: "(Buy) Order Quantity: 300 - Reject Count: 6"
  },
  {
    time: "14:01:29",
    client: "caerusx",
    ticker: "GE",
    title: "aggregate volume",
    urgent: "1",
    message: "(Sell) - Rejected Order Quantity: 100 - Mkt or Limit Price: 2.34"
  },
  {
    time: "14:01:28",
    client: "caerusx",
    ticker: "CUZ",
    title: "price limit",
    urgent: "1",
    message: "(Buy) Order Quantity: 300 - Reject Count: 6"
  },
  {
    time: "14:01:27",
    client: "caerusx",
    ticker: "DVA",
    title: "order quantity",
    urgent: "1",
    message:
      "Partially Filled Order Quantity: 1,618,520 -Total Notional: 13,433,716"
  },
  {
    time: "14:01:26",
    client: "chlmnms",
    ticker: "FCAU",
    title: "volume limit",
    urgent: "1",
    message: "Total Order Quantity: 9,753 - Day Vol: 7,354 - % Vol: 132.62"
  },
  {
    time: "14:01:25",
    client: "deshdma",
    ticker: "TWTR",
    title: "aggregate volume",
    urgent: "1",
    message: "(Buy) - PendingNew Order Quantity: 2,000,000 - Last Shares: N/A"
  }
];

export default alertArray;
